/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../common/currency';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "beemo": {
        "nested": {
          "api": {
            "nested": {
              "v2": {
                "nested": {
                  "reporting": {
                    "nested": {
                      "GiftCardUsage": {
                        "fields": {
                          "usedGiftCards": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional"
                          },
                          "giftCardAmountLoaded": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "giftCardLoadedCount": {
                            "type": "int64",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "GetProductUsageRequest": {
                        "fields": {
                          "merchantToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "subunitToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          }
                        }
                      },
                      "GetProductUsageResponse": {
                        "fields": {
                          "giftCardUsage": {
                            "type": ".squareup.beemo.api.v2.reporting.GiftCardUsage",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GiftCardUsage && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GetProductUsageRequest && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.reporting?.nested?.GetProductUsageResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE GiftCardUsage @ squareup/beemo/v2/reporting/product.proto at 8:1
 */
export const GiftCardUsage = $root.lookupType('squareup.beemo.api.v2.reporting.GiftCardUsage');
fixType(GiftCardUsage);
Builder.createAndAttachToType(GiftCardUsage);
/**
 * SOURCE GetProductUsageRequest @ squareup/beemo/v2/reporting/product.proto at 17:1
 */
export const GetProductUsageRequest = $root.lookupType('squareup.beemo.api.v2.reporting.GetProductUsageRequest');
fixType(GetProductUsageRequest);
Builder.createAndAttachToType(GetProductUsageRequest);
/**
 * SOURCE GetProductUsageResponse @ squareup/beemo/v2/reporting/product.proto at 22:1
 */
export const GetProductUsageResponse = $root.lookupType('squareup.beemo.api.v2.reporting.GetProductUsageResponse');
fixType(GetProductUsageResponse);
Builder.createAndAttachToType(GetProductUsageResponse);